<template>
  <div class="clock" v-if="clock">
    <audio style="display:none;" :src="clock.info.clock_link" controls></audio>
    <audio controls ref="audio" loop="loop" style="display:none;">
      <source :src="clock.info.clock_link" ref="msource" type="audio/wav" />
      您的浏览器不支持音频播放
    </audio>
    <div
      class="img_box"
      :style="'background-image:url(' + clock.info.clock_image + ')'"
    >
      <!-- <img :src="clock.info.clock_image" /> -->
    </div>
    <div class="clock_header">
      <div class="header_left">
        <img
          v-if="tem"
          :src="
            'https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/temp/' +
              tem.img +
              '.png'
          "
          alt=""
        />
        <div class="left_right">
          <div class="week">
            <span>{{ tem.city }}</span> · <span>{{ tem.week }}</span>
          </div>
          <div class="tem">
            <span>{{ tem.temp }}℃ · {{ tem.weather }}</span>
            <span></span>
          </div>
        </div>
      </div>
      <div class="header_right">
        <img
          v-if="playing"
          @click="plays(0)"
          src="../../../assets/images/clock_play.png"
          alt=""
        />
        <img
          v-else
          @click="plays(1)"
          src="../../../assets/images/clock_playing.gif"
          alt=""
        />
      </div>
    </div>
    <div class="info_box">
      <div class="info_left">
        <img :src="userInfo.avatar" />
      </div>
      <div class="info_right">
        <p>{{ userInfo.nickname }}</p>
        <p>{{ clock.UserClockCount }}人正在共同打卡</p>
      </div>
    </div>
    <div class="clock_box">
      <div class="clock_top">
        <div
          :class="isShow == 0 ? 'top_item active' : 'top_item'"
          @click="select(0)"
        >
          今日打卡
        </div>
        <div
          :class="isShow == 1 ? 'top_item active' : 'top_item'"
          @click="select(1)"
        >
          今日快讯
        </div>
      </div>
      <div class="clock_bottom" v-if="isShow == 0">
        <div class="title van-ellipsis">{{ clock.info.clock_name }}</div>
        <div class="count">
          第<span>{{ clock.count }}</span
          >天
        </div>
        <div class="time">
          <p>{{ formatTimer }}/{{ timer }}</p>
          <p>农历{{ getLunarDay.dateStr }}</p>
        </div>
        <div class="content">{{ clock.info.clock_content }}</div>
      </div>
      <div class="flash_box" v-if="isShow == 1">
        <div
          class="flash_item"
          v-for="(item, index) in newList.list"
          :key="index"
        >
          <div class="item_left">
            <div class="icon">
              <div class="box"></div>
            </div>
            <div class="tag"></div>
          </div>
          <div class="item_right">
            <div class="right_time">{{ item.behot_time }}</div>
            <div class="right_title">{{ item.title }}</div>
            <div class="right_content">
              {{ item.abstract }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tag, Icon, Progress, Image as VanImage } from "vant";
import { getClock, getNewsList } from "@/api/lcapi";
import { getWechatConfig, getShare } from "@/api/public";
import { getUser } from "@api/user";
import { getLunar } from "chinese-lunar-calendar";
import { openShareAll } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import axios from "axios";
import wx from "weixin-js-sdk";
import { login } from "../../../api/user";
export default {
  name: "Clock",
  components: {
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [Progress.name]: Progress,
    // [VanImage.name]: VanImage,
  },
  data() {
    return {
      playing: false,
      date: new Date().getDay(),
      clock: "",
      userInfo: "",
      duration: 0,
      currentTime: 0,
      getLunarDay: "",
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      date1: new Date().getDate(),
      isShow: 0,
      city: "",
      tem: "",
      higher: "",
      newList: "",
    };
  },
  computed: {
    // 当前时间格式化
    formatTimer: function() {
      let date = new Date();
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      // let h = date.getHours();
      // h = h < 10 ? "0" + h : h;
      // let m = date.getMinutes();
      // m = m < 10 ? "0" + m : m;
      // let s = date.getSeconds();
      // s = s < 10 ? "0" + s : s;
      return MM + "." + d;
    },
    // 获取当前星期几
    timer() {
      let d = new Date().getDay();
      let x;
      switch (d) {
        case 0:
          x = "周日";
          break;
        case 1:
          x = "周一";
          break;
        case 2:
          x = "周二";
          break;
        case 3:
          x = "周三";
          break;
        case 4:
          x = "周四";
          break;
        case 5:
          x = "周五";
          break;
        case 6:
          x = "周六";
          break;
      }
      return x;
    },
  },
  created() {
    this.getClock();
  },
  mounted() {
    const that = this;
    this.getNewsList();
    this.User();
    // 获取农历
    this.getLunarDay = getLunar(this.year, this.month, this.date1);
    setTimeout(() => {
      this.$refs.audio.play();
    }, 1000);
  },
  beforeDestroy() {
    if (isWeixin()) {
      getShare().then((res) => {
        var data = res.data.data;
        var configAppMessage = {
          desc: data.synopsis,
          title: data.title,
          link: "https://jiaojiao.yanjiusuo.xyz",
          imgUrl: data.img,
        };
        openShareAll(configAppMessage);
      });
    }
  },
  methods: {
    /**
     * 获取个人信息
     */
    User() {
      const that = this;
      getUser().then((res) => {
        that.userInfo = res.data;
      });
    },
    /**
     * 获取天气
     */
    getTem(latitude, longitude) {
      const that = this;
      axios({
        url:
          latitude == 0 && longitude == 0
            ? "https://jisutqybmf.market.alicloudapi.com/weather/query?city=成都"
            : "https://jisutqybmf.market.alicloudapi.com/weather/query?location=" +
              latitude +
              "," +
              longitude,
        method: "get", //get
        headers: { Authorization: "APPCODE 0bb3bef050974f4b8bd04d5ad911790b" },
      }).then((res) => {
        this.tem = res.data.result;
        console.log(this.tem);
      });
    },
    /**
     * 获取打卡数据
     */
    getClock() {
      getClock().then((res) => {
        this.clock = res.data;
        const that = this;
        if (this.$route.query.clock_verify != 9) {
          if (isWeixin()) {
            wx.getLocation({
              success: function(res) {
                let latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                let longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                that.getTem(latitude, longitude);
              },
              cancel: function(res) {
                that.getTem(0, 0);
                alert("用户拒绝授权获取地理位置");
              },
            });
            var configAppMessage = {
              desc: that.clock.info.clock_content,
              title:
                " 【早安第" +
                that.clock.count +
                "天】 " +
                that.clock.info.clock_name,
              link: "https://jiaojiao.yanjiusuo.xyz" + that.$route.fullPath,
              imgUrl: that.clock.info.clock_image,
            };
            openShareAll(configAppMessage);
          }
        } else {
          getWechatConfig().then((data) => {
            wx.config({
              debug: false,
              appId: data.data.appId,
              timestamp: data.data.timestamp,
              timestamp: data.data.timestamp,
              nonceStr: data.data.nonceStr,
              signature: data.data.signature,
              jsApiList: [
                "checkJsApi",
                "onMenuShareTimeline",
                "onMenuShareAppMessage",
                "updateAppMessageShareData",
                "updateTimelineShareData",
                "getLocation",
              ],
              openTagList: ["wx-open-launch-weapp"],
            });
            wx.ready(function() {
              var configAppMessage = {
                desc: that.clock.info.clock_content,
                title:
                  " 【早安第" +
                  that.clock.count +
                  "天】 " +
                  that.clock.info.clock_name,
                link: "https://jiaojiao.yanjiusuo.xyz" + that.$route.fullPath,
                imgUrl: that.clock.info.clock_image,
              };
              openShareAll(configAppMessage);
              wx.getLocation({
                success: function(res) {
                  let latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                  let longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                  that.getTem(latitude, longitude);
                },
                cancel: function(res) {
                  that.getTem(0, 0);
                  alert("用户拒绝授权获取地理位置");
                },
              });
            });
          });
        }

        // getWechatConfig().then((data) => {
        //   wx.config({
        //     debug: false,
        //     appId: data.data.appId,
        //     timestamp: data.data.timestamp,
        //     timestamp: data.data.timestamp,
        //     nonceStr: data.data.nonceStr,
        //     signature: data.data.signature,
        //     jsApiList: [
        //       "checkJsApi",
        //       "onMenuShareTimeline",
        //       "onMenuShareAppMessage",
        //       "updateAppMessageShareData",
        //       "updateTimelineShareData",
        //       "onMenuShareQQ",
        //       "onMenuShareWeibo",
        //       "hideMenuItems",
        //       "showMenuItems",
        //       "hideAllNonBaseMenuItem",
        //       "showAllNonBaseMenuItem",
        //       "translateVoice",
        //       "startRecord",
        //       "stopRecord",
        //       "onRecordEnd",
        //       "playVoice",
        //       "pauseVoice",
        //       "stopVoice",
        //       "uploadVoice",
        //       "downloadVoice",
        //       "chooseImage",
        //       "previewImage",
        //       "uploadImage",
        //       "downloadImage",
        //       "getNetworkType",
        //       "openLocation",
        //       "getLocation",
        //       "hideOptionMenu",
        //       "showOptionMenu",
        //       "closeWindow",
        //       "scanQRCode",
        //       "chooseWXPay",
        //       "openProductSpecificView",
        //       "addCard",
        //       "chooseCard",
        //       "openCard",
        //     ],
        //     openTagList: ["wx-open-launch-weapp"],
        //   });
        //   wx.ready(function() {
        //     //config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中
        //     wx.updateAppMessageShareData({
        //       title: that.clock.info.clock_name, // 分享标题
        //       desc: that.clock.info.clock_content, // 分享描述
        //       link: "https://jiaojiao.yanjiusuo.xyz" + that.$route.fullPath, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        //       imgUrl: that.clock.info.clock_image, // 分享图标
        //       success: function() {
        //         // 设置成功
        //       },
        //     });
        //     wx.onMenuShareAppMessage({
        //       title: that.clock.info.clock_name, // 分享标题
        //       desc: that.clock.info.clock_content, // 分享描述
        //       link: "https://jiaojiao.yanjiusuo.xyz" + that.$route.fullPath, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        //       imgUrl: that.clock.info.clock_image, // 分享图标
        //       success: function() {
        //         // 设置成功
        //       },
        //     });
        //     wx.updateTimelineShareData({
        //       title: that.clock.info.clock_name, // 分享标题
        //       desc: that.clock.info.clock_content, // 分享描述
        //       link: "https://jiaojiao.yanjiusuo.xyz" + that.$route.fullPath, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        //       imgUrl: that.clock.info.clock_image, // 分享图标
        //       success: function() {
        //         // 设置成功
        //       },
        //     });
        //     wx.onMenuShareTimeline({
        //       title: that.clock.info.clock_name, // 分享标题
        //       desc: that.clock.info.clock_content, // 分享描述
        //       link: "https://jiaojiao.yanjiusuo.xyz" + that.$route.fullPath, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        //       imgUrl: that.clock.info.clock_image, // 分享图标
        //       success: function() {
        //         // 设置成功
        //       },
        //     });
        //   });
        //   wx.error(function(res) {
        //     // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        //   });
        // });
      });
    },
    /**
     * 音乐播放
     */
    plays(e) {
      // e 0 开始播放 1 暂停播放
      if (e == 0) {
        this.$refs.audio.play();
        this.playing = false;
        return;
      }
      if (e == 1) {
        this.$refs.audio.pause();
        this.playing = true;
        return;
      }
    },
    /**
     * audio自身事件
     * */
    // 当音频播放
    // onPlay() {
    //   console.log("开始播放声音");
    //   this.playing = false;
    // },
    // // 当音频暂停
    // onPause() {
    //   console.log("暂停播放声音");
    //   this.playing = true;
    // },
    // //播放完毕执行
    // overAudio() {
    //   console.log("播放声音完毕");
    //   this.$refs.audio.play();
    // },
    /**
     * 切换
     */
    select(index) {
      this.isShow = index;
    },
    /**
     * 获取快讯
     */
    getNewsList() {
      getNewsList({ startTime: 0 }).then((res) => {
        this.newList = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.clock {
  position: relative;
  padding-bottom: 0.5rem;
  .img_box {
    position: absolute;
    font-size: 0;
    width: 100%;
    height: 4.24rem;
    top: 0;
    z-index: -1;
    background-position: top;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .clock_header {
    background: rgba(white, 0.25);
    height: 0.84rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.3rem;
    font-size: 0;
    .header_left {
      display: flex;
      align-items: center;
      img {
        width: 0.53rem;
        height: 0.53rem;
      }
      .left_right {
        font-size: 0.28rem;
        color: #ffffff;
        font-weight: bold;
        padding-left: 0.15rem;
        div {
          &:last-child {
            font-size: 0.18rem;
          }
        }
      }
    }
    .header_right {
      img {
        width: 0.61rem;
        height: 0.61rem;
      }
    }
  }
  .info_box {
    background: #ffffff;
    margin: 2.7rem 0.3rem 0 0.3rem;
    box-shadow: 0px 0px 0.2rem 0px rgba(168, 168, 168, 0.15);
    border-radius: 0.14rem;
    display: flex;
    align-items: center;
    padding: 0.35rem 0.3rem;
    .info_left {
      img {
        width: 0.84rem;
        height: 0.84rem;
        border-radius: 50%;
      }
    }
    .info_right {
      padding-left: 0.25rem;
      p {
        line-height: 0.42rem;
        &:first-child {
          font-size: 0.32rem;
        }
        &:last-child {
          font-size: 0.26rem;
          color: #999999;
        }
      }
    }
  }
  .clock_box {
    margin: 0.25rem 0.3rem 0 0.3rem;
    background: #ffffff;
    box-shadow: 0px 0px 0.2rem 0px rgba(168, 168, 168, 0.15);
    border-radius: 0.14rem;
    .clock_top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 0.01rem solid #ededed;
      .top_item {
        flex: 1;
        text-align: center;
        line-height: 0.9rem;
        font-size: 0.3rem;
        &.active {
          color: #ff410a;
          position: relative;
          &::after {
            position: absolute;
            content: "";
            width: 1.2rem;
            height: 0.06rem;
            background: #ff410a;
            border-radius: 0.03rem;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
    }
    .clock_bottom {
      .title {
        margin-top: 0.6rem;
        font-size: 0.34rem;
        font-weight: 500;
        text-align: center;
        padding: 0 1rem;
        line-height: 0.34rem;
      }
      .count {
        font-size: 0.34rem;
        text-align: center;
        margin-top: 0.2rem;
        line-height: 0.34rem;
        span {
          font-size: 0.44rem;
          color: #ff410a;
          font-weight: bold;
          margin: 0 0.1rem;
        }
      }
      .time {
        text-align: center;
        margin-top: 0.25rem;
        p {
          &:first-child {
            font-size: 0.3rem;
            letter-spacing: 0.02rem;
          }
          &:last-child {
            margin-top: 0.15rem;
            font-size: 0.28rem;
            color: #999999;
          }
        }
      }
      .content {
        margin-top: 0.48rem;
        padding: 0 0.46rem 0.9rem 0.46rem;
        font-size: 0.3rem;
        color: #666666;
        white-space: pre-wrap;
      }
    }
    .flash_box {
      background: #fff;
      padding: 0.5rem 0.3rem;
      .flash_item {
        display: flex;
        justify-content: space-between;
        &:last-child {
          .item_right {
            padding-bottom: 0;
          }
        }
        .item_left {
          .icon {
            width: 0.24rem;
            height: 0.24rem;
            background: rgba($color: #ff410a, $alpha: 0.4);
            border-radius: 50%;
            position: relative;
            div {
              width: 0.12rem;
              height: 0.12rem;
              background: #ff410a;
              border-radius: 50%;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
          .tag {
            width: 0.02rem;
            background: #f3f3f3;
            height: 100%;
            margin: 0 auto;
          }
        }
        .item_right {
          padding-left: 0.17rem;
          padding-bottom: 0.7rem;
          flex: 1;
          .right_time {
            font-size: 0.24rem;
            line-height: 0.24rem;
            height: 0.24rem;
            color: #999999;
          }
          .right_title {
            font-size: 0.3rem;
            font-weight: bold;
            margin-top: 0.35rem;
          }
          .right_content {
            font-size: 0.26rem;
            color: #666666;
            margin-top: 0.25rem;
          }
        }
      }
    }
  }
}
</style>
